import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "nav-ar-down",
  "use": "nav-ar-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"nav-ar-down\">\n  <path d=\"M6.70538 9.2947C7.09466 8.90543 7.72569 8.90509 8.11538 9.29393L12 13.1701L15.8846 9.29393C16.2743 8.90509 16.9053 8.90543 17.2946 9.2947C17.6842 9.68428 17.6842 10.3159 17.2946 10.7055L12 16.0001L6.70538 10.7055C6.31581 10.3159 6.31581 9.68428 6.70538 9.2947Z\" fill=\"#003595\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol